<script>
import maxLengthCodePoints from '@/support/customValidators/maxLengthCodePoints'

export const MAX_SEO_KEYWORD = 150
export const MAX_SEO_TITLE = 60
export const MAX_SEO_SUBTITLE = 60
export const MAX_META_DESCRIPTION = 160

export default {
  name: 'ArticleSeoBasicStep',
  components: {
    InputField: () => import('@/components/general/InputField'),
    TextareaField: () => import('@/components/general/TextareaField'),
    FormSection: () => import('@/components/general/FormSection')
  },

  props: {
    formData: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      MAX_SEO_KEYWORD,
      MAX_SEO_TITLE,
      MAX_SEO_SUBTITLE,
      MAX_META_DESCRIPTION
    }
  },

  validations () {
    return {
      formData: {
        seo_keyword: { maxLength: maxLengthCodePoints(MAX_SEO_KEYWORD) },
        seo_title: { maxLength: maxLengthCodePoints(MAX_SEO_TITLE) },
        seo_subtitle: { maxLength: maxLengthCodePoints(MAX_SEO_SUBTITLE) },
        meta_description: { maxLength: maxLengthCodePoints(MAX_META_DESCRIPTION) }
      }
    }
  },

  methods: {
    // eslint-disable-next-line vue/no-unused-properties -- called from parent via $refs.currentStep.validate()
    validate () {
      this.$v.$touch()

      return !this.$v.$invalid
    },

    emit (patch) {
      this.$emit('input', patch)
    },

    onSeoKeywordInput (value) { this.emit({ seo_keyword: value }) },
    onSeoTitleInput (value) { this.emit({ seo_title: value }) },
    onSeoSubtitleInput (value) { this.emit({ seo_subtitle: value }) },
    onMetaDescriptionInput (value) { this.emit({ meta_description: value }) }
  }
}
</script>

<template>
  <form
    class="article-content-form"
    @submit.prevent
  >
    <FormSection>
      <InputField
        :label="$t('articles.form:seo.keyword')"
        allow-emoji
        :value="formData.seo_keyword"
        :validation="$v.formData.seo_keyword"
        :counter="MAX_SEO_KEYWORD"
        :under-description="$t('articles.form:seo.keyword.description')"
        @input="onSeoKeywordInput"
      />

      <InputField
        :label="$t('articles.form:seo.title')"
        allow-emoji
        :value="formData.seo_title"
        :validation="$v.formData.seo_title"
        :counter="MAX_SEO_TITLE"
        :under-description="$t('articles.form:seo.title.description')"
        @input="onSeoTitleInput"
      />

      <InputField
        :label="$t('articles.form:seo.subtitle')"
        allow-emoji
        :value="formData.seo_subtitle"
        :validation="$v.formData.seo_subtitle"
        :counter="MAX_SEO_SUBTITLE"
        @input="onSeoSubtitleInput"
      />

      <TextareaField
        :label="$t('articles.form:meta.description')"
        allow-emoji
        :value="formData.meta_description"
        :validation="$v.formData.meta_description"
        :counter="MAX_META_DESCRIPTION"
        :auto-grow="true"
        :under-description="$t('articles.form:meta.description.description')"
        @input="onMetaDescriptionInput"
      />
    </FormSection>
  </form>
</template>
